<template>
    <div class="container" style="padding-left:12px">
      <v-row
        class="pb-3">
          <v-col
              cols="12">
              HURTO
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card
            :loading="loading"
            
          >
            
            <v-card-text>
              <div class="container">
              <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col
                            cols="12"
                            md="2"
                            class="pb-0 pt-0">
                            <v-combobox
                              label="Abrev."
                              :items="itemsAbrev"
                              dense
                              outlined
                              solo
                            ></v-combobox>
                        </v-col>
                        <v-col
                            cols="12"
                            md="5"
                            class="pb-0 pt-0">
                            <v-text-field
                                v-model="entradaEn"
                                label="Nombre"
                                outlined
                                clearable
                                dense
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="5"
                            class="pb-0 pt-0">
                            <v-text-field
                                v-model="entradaEn"
                                label="Radicado"
                                outlined
                                clearable
                                dense
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            class="pb-0 pt-0">
                            <v-text-field
                                label="IMEI"
                                outlined
                                clearable
                                dense
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            class="pb-0 pt-0">
                            <v-text-field
                                label="IMEI 1"
                                outlined
                                clearable
                                dense
                                solo
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="4"
                            class="pb-0 pt-0">
                            <v-text-field
                                label="IMEI 2"
                                outlined
                                clearable
                                dense
                                solo
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            </div>
            </v-card-text>
            <v-card-actions>
                  <v-btn
                    color="info"
                    text
                    @click="reserve"
                    >
                    GENERAR
                  </v-btn>
              
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
        
    </div>
</template>

<script>
  import Constant from '../util/constant';
  import UtilMethod from '../util/utilMethod';
  import { v4 as uuidv4 } from 'uuid';

  export default {
    name: 'Hurto',

    data:()=>({
        entradaEs: null,
        entradaEn: null,
        salida: null,
        loader: null,
        loading: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,

        listStringEs:[],
        listStringEn:[],
        itemsAbrev:[
          "Sr.",
          "Sra."
        ]
    }),
    components: {
      //HelloWorld,
    },
    mounted(){
        if(localStorage.getItem('listEs')){
            this.listStringEs = JSON.parse(localStorage.getItem('listEs'));
        }

        if(localStorage.getItem('listEn')){
            this.listStringEn = JSON.parse(localStorage.getItem('listEn'));
        }
    },
    methods:{
        async process(){
            this.loading4 = true;
            //this.loader = 'loading4';
            let nameEntrada = this.entradaEs.toLowerCase()
            .replaceAll(" ","_")
            .replaceAll("ñ","n")
            .replaceAll("á","a")
            .replaceAll("é","e")
            .replaceAll("í","i")
            .replaceAll("ó","o")
            .replaceAll("ú","u")
            .replaceAll("¿","")
            .replaceAll("?","")
            .replaceAll("¡","")
            .replaceAll("!","")
            .replaceAll(",","")
            .replaceAll("-","")
            //.replaceAll("'","")
            .replaceAll(".","")
            .replaceAll(" de ","")
            .replaceAll(" la ","")
            .replaceAll("la ","")
            .replaceAll(" tu ","")
            .replaceAll("tu ","");
            this.entradaEn = await this.getEnglishEnter(this.entradaEs);
            let textSalidaEs =`<string name="${nameEntrada}">${this.entradaEs}</string>`;
            let textSalidaEn =`<string name="${nameEntrada}">${this.entradaEn}</string>`;
            let textCopied = `@string/${nameEntrada}`;
            this.salida = `${textSalidaEs}\n${textSalidaEn}\n${textCopied}`;
            navigator.clipboard.writeText(textCopied);
            this.listStringEs.push({value:textSalidaEs});
            localStorage.setItem('listEs',  JSON.stringify(this.listStringEs));
            this.listStringEn.push({value:textSalidaEn});
            localStorage.setItem('listEn',  JSON.stringify(this.listStringEn));
            this.loading4 = false;
        },
        delTable(){
            if(localStorage.getItem('listEs')){
                localStorage.removeItem('listEs');
            }

            if(localStorage.getItem('listEn')){
                localStorage.removeItem('listEn');
            }
            this.listStringEs=[];
            this.listStringEn=[];
        },
        async getEnglishEnter(text){
            let headers= {
                'content-type': 'application/json',
                'Ocp-Apim-Subscription-Key': Constant.KEY_SUSCRIPTION_AZURE,
                'Ocp-Apim-Subscription-Region': Constant.REGION_AZURE,
                'Content-type': 'application/json',
                'X-ClientTraceId': uuidv4().toString()
            };

            let body = [{'text': text}];

            let callbackThen = (response) => {
                let objOut = {
                    code:null,
                    message:null,
                    data:null
                };

                if(response.status == 200){
                    objOut.code = 1;
                    let translations = response.data[0].translations;
                    translations.forEach(item => {
                        objOut.message=item.text;
                    });
                }else{
                    objOut.message = "Oops, algo pasó..., Code: "+response.status;
                }
                
                return objOut;
            }
            
            let retorno = await UtilMethod.execApi("POST2",Constant.URI_TRANSLATE_AZURE+"--/translate--"+"?api-version=3.0&from=es&to=en",body,headers,callbackThen);
            return retorno.message;
        }
    },
    /*watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 100)

        this.loader = null
      },
    },*/
  }
</script>
<!--<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>-->